import React from "react";

const HomeScreen: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white p-6">
      <meta name="theme-color" content="#ffffff" />

      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="#ffffff" />
      <header className="w-full max-w-md bg-white shadow-md py-4 px-6 flex items-center justify-center font-gowun">
        <h1 className="text-xl font-bold text-green-600">안녕하세요!</h1>
      </header>
    </div>
  );
};

export default HomeScreen;
